import Component from '@glimmer/component';

import { array } from '@ember/helper';
import LinksTo from 'ember-route-state/components/links-to.gjs';

import ReadMore from 'rise-ui/components/read-more.gjs';
import and from 'rise-ui/helpers/and.js';
import date from 'rise-ui/helpers/date.js';
import eq from 'rise-ui/helpers/eq.js';
import gt from 'rise-ui/helpers/gt.js';
import limit from 'rise-ui/helpers/limit.js';
import or from 'rise-ui/helpers/or.js';
import streq from 'rise-ui/helpers/streq.js';
import trustedHtml from 'rise-ui/helpers/trusted-html.js';

export default class AnnouncementSummariesComponent extends Component {
  <template>
    <ul class="c-announcement-summaries c-media-list">
      {{#each (limit @announcements @limit) as | announcement |}}
        <li class="c-media-list__item c-media">
          {{#if announcement.image.url}}
            <img
              class="c-media__image c-media-list__item-image"
              src={{announcement.image.url}}
              alt={{announcement.image.alt}}
            >
          {{/if}}
          <div class="c-media__body">
            <div class="c-media__head">
              <h4 class="c-media__title">
                <LinksTo @route={{array "announcement" announcement.id}}>
                  {{~announcement.title~}}
                </LinksTo>
              </h4>
              <div class="c-media__date"
              >{{date announcement.announcementDate "long"}}</div>
            </div>
            <ReadMore as | rm |>
              <rm.content>
                <div class="c-media__content c-announcement-summaries__content">
                  <div class="c-announcement-summaries__summary">
                    {{announcement.bodySummary}}
                  </div>
                  <div class="c-html-content c-announcement-summaries__body">
                    {{trustedHtml announcement.bodyProcessed}}
                  </div>
                </div>
              </rm.content>
              <rm.button>
                <LinksTo @route={{array "announcement" announcement.id}}
                >Read More</LinksTo>
              </rm.button>
            </ReadMore>
          </div>
        </li>
      {{else}}
        <span class="c-no-result">No news releases available.</span>
      {{/each}}
    </ul>
    {{#if (or
      (streq @more true)
      (and (eq @more "auto") (gt @announcements.length @limit))
    )}}
      <p><em>(<LinksTo @route="announcements"
      >More Announcements</LinksTo>)</em></p>
    {{/if}}
    {{yield}}
  </template>
}
